import ResflowLogoutModalContainer from './ResflowLogoutModalContainer';

export default ResflowLogoutModalContainer;
